import { Phone, MessageCircle, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

export const Hero = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/918679334866', '_blank');
  };

  return (
    <section id="home" className="relative pt-24 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden">
      {/* Background with subtle gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-orange-50 via-amber-50 to-yellow-50 -z-10" />
      
      {/* Decorative elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-orange-200/30 rounded-full blur-3xl -z-10" />
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-amber-200/20 rounded-full blur-3xl -z-10" />

      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto">
          {/* Badge */}
          <div className="inline-flex items-center px-4 py-2 bg-white rounded-full shadow-sm border border-orange-200 mb-6">
            <span className="text-orange-600 font-semibold text-sm">Trusted Real Estate Consultant in Vrindavan</span>
          </div>

          {/* Main Heading */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            Find Your Perfect
            <span className="text-orange-600"> Spiritual Home</span>
            <br />in Vrindavan
          </h1>

          {/* Subheading */}
          <p className="text-lg sm:text-xl text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
            MVDA & RERA approved properties in premium gated colonies. Specializing in flats, plots, independent houses, studio apartments, and villas.
          </p>

          {/* Key Features */}
          <div className="flex flex-wrap justify-center gap-6 mb-10">
            {['Buy', 'Sell', 'Invest'].map((item) => (
              <div key={item} className="flex items-center space-x-2 text-gray-700">
                <ArrowRight className="w-5 h-5 text-orange-600" />
                <span className="font-medium text-lg">{item}</span>
              </div>
            ))}
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a href="tel:8679334866">
              <Button size="lg" className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-6 text-lg shadow-lg hover:shadow-xl transition-all duration-300">
                <Phone className="w-5 h-5 mr-2" />
                Call Now: 8679334866
              </Button>
            </a>
            <Button 
              size="lg" 
              variant="outline" 
              className="border-2 border-orange-600 text-orange-600 hover:bg-orange-50 px-8 py-6 text-lg transition-all duration-300"
              onClick={handleWhatsApp}
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              WhatsApp Us
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="mt-12 pt-8 border-t border-orange-200">
            <div className="flex flex-wrap justify-center items-center gap-8 text-center">
              <div>
                <p className="text-3xl font-bold text-orange-600">100+</p>
                <p className="text-sm text-gray-600 mt-1">Properties Sold</p>
              </div>
              <div className="w-px h-12 bg-orange-200" />
              <div>
                <p className="text-3xl font-bold text-orange-600">MVDA</p>
                <p className="text-sm text-gray-600 mt-1">Approved Only</p>
              </div>
              <div className="w-px h-12 bg-orange-200" />
              <div>
                <p className="text-3xl font-bold text-orange-600">RERA</p>
                <p className="text-sm text-gray-600 mt-1">Certified</p>
              </div>
              <div className="w-px h-12 bg-orange-200" />
              <div>
                <p className="text-3xl font-bold text-orange-600">500+</p>
                <p className="text-sm text-gray-600 mt-1">Happy Clients</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};